import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

import TimePeriod from 'modules/timeoff/lib/BlockedPeriods/TimePeriod'
import type { ITimePeriod as TimePeriodAttributes } from 'modules/timeoff/lib/BlockedPeriods/TimePeriod'

interface Props {
  payload: TimePeriodAttributes
  onEdit: (period: TimePeriodAttributes) => void
  onDelete: (period: TimePeriodAttributes) => void
}

const itemSubtitle = (period: TimePeriod) => {
  if (period.byTimeRange) {
    return {
      from: i18n.t('settings.timeoff_blocked_periods.detail.time_periods.time_period.from_date', {
        date: period.formattedStartOn,
      }),
      to: i18n.t('settings.timeoff_blocked_periods.detail.time_periods.time_period.to_date', {
        date: period.formattedFinishOn,
      }),
    }
  } else if (period.byContractStartDate) {
    const duration = period.duration
    const to = period.durationInDays
      ? i18n.t('settings.timeoff_blocked_periods.detail.time_periods.time_period.duration_days', {
          duration,
        })
      : i18n.t('settings.timeoff_blocked_periods.detail.time_periods.time_period.duration_months', {
          duration,
        })
    return {
      from: i18n.t(
        'settings.timeoff_blocked_periods.detail.time_periods.time_period.from_contract_start_date'
      ),
      to: to,
    }
  }
  return {}
}

const PeriodItem = ({ payload, onEdit, onDelete }: Props) => {
  const period = new TimePeriod(payload)
  const { from, to } = itemSubtitle(period)

  return (
    <Box flexGrow paddingX="s24" paddingY="s16">
      <Box flexGrow flexDirection="row" justifyContent="spaceBetween" paddingBottom="s8">
        <Box>
          <Text.Header2>{period.name}</Text.Header2>
          <Box flexGrow justifyContent="spaceBetween">
            <Text.Normal color="grey600">{from}</Text.Normal>
            <Text.Normal color="grey600">{to}</Text.Normal>
          </Box>
        </Box>
        <PopoverMenu type="list">
          <PopoverMenu.Trigger>
            <Button.Decorative type="secondary" iconName="ellipsis" />
          </PopoverMenu.Trigger>
          <PopoverMenu.Content side="bottom" align="end">
            <PopoverMenu.TouchableOption
              title={i18n.t('settings.timeoff_blocked_periods.detail.time_periods.edit')}
              onClick={() => onEdit(payload)}
            />
            <PopoverMenu.TouchableOption
              title={i18n.t('settings.timeoff_blocked_periods.detail.time_periods.delete')}
              danger
              onClick={() => onDelete(payload)}
            />
          </PopoverMenu.Content>
        </PopoverMenu>
      </Box>
    </Box>
  )
}

export default observer(PeriodItem)
